const pointToJittered = (value: number, scale: number) => {

  return value + scale * (Math.random() * (-1 - 1) + 1)
}

export default pointToJittered